import styled from 'styled-components';
import Image from 'next/image';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardsSlider from '../Common/CardSlider';

interface IStyledProps {
  isMobile?: boolean;
}

export const PageContainer = styled(Container)`
  display: flex !important;
  flex-direction: column;
  //max-width: 1250px;
  padding-top: 30px;
`;
export const PageContent = styled('div')<IStyledProps>`
  display: flex !important;
  flex-direction: ${({ isMobile }) => (isMobile && 'column-reverse') || 'row'};
`;

export const LeftSection = styled('div')`
  flex-basis: 30%;
`;
export const PriceBox = styled('div')`
  padding: 10px;
  position: relative;
  margin: 0 20px 30px 0;
  border-radius: 5px 0 0 5px;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  &:before {
    top: 0;
    width: 0;
    height: 0;
    left: 100%;
    content: '';
    position: absolute;
    border-left: 20px solid;
    border-top: 32px solid transparent !important;
    border-bottom: 32px solid transparent !important;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
export const PriceAndLastUpdate = styled('div')`
  padding: 0 0 0 15px;
  display: flex;
  flex-direction: column;
`;
export const PriceText = withStyles({
  h4: {
    fontSize: '25px',
    lineHeight: '25px',
  },
})(Typography);
export const PriceUpdateText = withStyles({
  h6: {
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
export const ProductTitle = withStyles({
  h3: {
    margin: '15px 0',
    fontSize: '30px',
    lineHeight: '34px',
  },
})(Typography);

// Right Section
export const RightSection = styled('div')<IStyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: ${({ isMobile }) => (isMobile && '100%') || '70%'};
  padding: ${({ isMobile }) => (isMobile && '0') || '0 0 0 30px'};
`;
export const AdContent = styled('div')``;
export const SharingAdSection = styled('div')`
  display: flex;
  justify-content: space-between;
`;
export const FavouriteListing = styled('div')`
  display: flex;
  align-items: center;
`;

export const IconTypography = styled(Typography)`
  display: flex;
`;
export const SliderImage = styled(Image)`
  object-fit: contain;
  object-position: center center;
`;
export const DetailsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const DetailItemContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
  width: 100%;
  -webkit-box-pack: justify;
  justify-content: space-between;
  font-size: 15px;
`;
export const DetailItem = styled.div`
  flex-basis: 50%;
  @media (max-width: 767px) {
    flex-basis: 100%;
  }
`;
export const DetailAttribute = styled.div`
  max-width: 50%;
  color: #000;
`;
export const DetailInfo = styled.div`
  flex-basis: 50%;
  text-align: left;
  color: #000;
`;
export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  border: 1px solid #dfdfdf;
  margin: 10px 0;
  font-size: 15px;
`;

export const Title = styled.h2`
  font-size: 20px;
  margin: 0 0 10px 0;
  font-weight: bold;
`;
export const productBreadcrumbs = {
  padding: '0 0 15px',
};

export const ListingDetailText = styled.div`
  line-height: 1.4;
  font-size: 14px;
`;
export const ListingDetailsContainer = styled.div``;
export const StyledMoreAdsSlider = styled(CardsSlider)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const MainSliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
};
